<div class="toast-parent" *ngFor="let toast of toasts ">
	<div *ngIf="toast.toastTypeNumber!=5" @slideIn @slideOut @triggerChildAnimation @verticalCollapse
		(@verticalCollapse.done)="animEnd($event)">
		<app-toast-item [toast]="toast" class="{{toast.class}}">
		</app-toast-item>
	</div>
	<div *ngIf="toast.toastTypeNumber==5">
		<app-toast-item [toast]="toast" (clearHideBoxToast)="clearPendingToasts({ hideBox: true })"
			class="{{toast.class}}">
		</app-toast-item>
	</div>
</div>